import Domain from "./domain-base";

export class ResetPasswordPolicyOptions extends Domain {
  autoEnrollEnabled = false;
}
